import React from "react";

/**
 * Skeleton Loader Component
 * Provides different skeleton types for various content layouts
 */
const SkeletonLoader = ({
  type = "card", // "card", "table", "list", "form", "chart", "avatar"
  count = 1,
  className = "",
  animated = true,
  variant = "default" // "default", "minimal", "pulse"
}) => {
  // Animation classes
  const animationClass = animated ? "animate-pulse" : "";
  
  // Variant classes
  const variantClasses = {
    default: "bg-slate-200",
    minimal: "bg-slate-100",
    pulse: "bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200"
  };

  const variantClass = variantClasses[variant];

  // Skeleton types
  const renderSkeleton = (type, index) => {
    switch (type) {
      case "card":
        return (
          <div key={index} className={`rounded-lg border border-slate-200 p-4 ${className}`}>
            <div className={`h-4 ${variantClass} rounded mb-3 w-3/4`}></div>
            <div className={`h-3 ${variantClass} rounded mb-2 w-full`}></div>
            <div className={`h-3 ${variantClass} rounded mb-2 w-2/3`}></div>
            <div className={`h-3 ${variantClass} rounded w-1/2`}></div>
          </div>
        );

      case "table":
        return (
          <div key={index} className={`border-b border-slate-200 py-3 ${className}`}>
            <div className="flex items-center space-x-4">
              <div className={`h-4 w-4 ${variantClass} rounded`}></div>
              <div className={`h-4 ${variantClass} rounded flex-1`}></div>
              <div className={`h-4 ${variantClass} rounded w-24`}></div>
              <div className={`h-4 ${variantClass} rounded w-20`}></div>
              <div className={`h-4 ${variantClass} rounded w-16`}></div>
            </div>
          </div>
        );

      case "list":
        return (
          <div key={index} className={`flex items-center space-x-3 py-2 ${className}`}>
            <div className={`h-10 w-10 ${variantClass} rounded-full`}></div>
            <div className="flex-1 space-y-2">
              <div className={`h-3 ${variantClass} rounded w-3/4`}></div>
              <div className={`h-2 ${variantClass} rounded w-1/2`}></div>
            </div>
          </div>
        );

      case "form":
        return (
          <div key={index} className={`space-y-4 ${className}`}>
            <div>
              <div className={`h-4 ${variantClass} rounded mb-2 w-24`}></div>
              <div className={`h-10 ${variantClass} rounded w-full`}></div>
            </div>
            <div>
              <div className={`h-4 ${variantClass} rounded mb-2 w-32`}></div>
              <div className={`h-20 ${variantClass} rounded w-full`}></div>
            </div>
            <div className={`h-10 ${variantClass} rounded w-24`}></div>
          </div>
        );

      case "chart":
        return (
          <div key={index} className={`space-y-3 ${className}`}>
            <div className={`h-4 ${variantClass} rounded w-32`}></div>
            <div className="flex items-end space-x-2 h-32">
              <div className={`w-8 ${variantClass} rounded-t`} style={{ height: '60%' }}></div>
              <div className={`w-8 ${variantClass} rounded-t`} style={{ height: '80%' }}></div>
              <div className={`w-8 ${variantClass} rounded-t`} style={{ height: '40%' }}></div>
              <div className={`w-8 ${variantClass} rounded-t`} style={{ height: '90%' }}></div>
              <div className={`w-8 ${variantClass} rounded-t`} style={{ height: '70%' }}></div>
            </div>
          </div>
        );

      case "avatar":
        return (
          <div key={index} className={`flex items-center space-x-3 ${className}`}>
            <div className={`h-12 w-12 ${variantClass} rounded-full`}></div>
            <div className="space-y-2">
              <div className={`h-3 ${variantClass} rounded w-20`}></div>
              <div className={`h-2 ${variantClass} rounded w-16`}></div>
            </div>
          </div>
        );

      default:
        return (
          <div key={index} className={`h-4 ${variantClass} rounded ${className}`}></div>
        );
    }
  };

  return (
    <div className={`${animationClass}`}>
      {Array.from({ length: count }, (_, index) => renderSkeleton(type, index))}
    </div>
  );
};

export default SkeletonLoader; 